// extracted by mini-css-extract-plugin
module.exports = {"dialog":"dialog_dialog__pBoto","backdrop":"dialog_backdrop__8muVq","closeButton":"dialog_closeButton__ianQx"};